import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 1,
  class: "container-fluid"
}
const _hoisted_6 = { class: "mt-1" }
const _hoisted_7 = { class: "card-title" }
const _hoisted_8 = { class: "badge rounded-pill bg-success" }
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = { class: "flex-fill" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "flex-fill" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "flex-fill" }
const _hoisted_17 = { key: 0 }


import { FIGURER_OPSLAG, OPDATER_FIGUR_MUTATION } from "@/constants/graphql";
import { useMutation, useQuery, useResult } from "@vue/apollo-composable";


export default /*#__PURE__*/_defineComponent({
  __name: 'MinifigurElement',
  props: {
    uuid: null,
    antalISaet: null
  },
  setup(__props: any) {

const props = __props as {
  uuid: string;
  antalISaet?: number;
}



const { result: figurResult, loading: figurLoading } = useQuery(
  FIGURER_OPSLAG,
  () => {
    return { uuid: props.uuid };
  }
);

const figur = useResult(figurResult, undefined, data => data.figur[0]);

const { mutate: opdaterFigur } = useMutation(OPDATER_FIGUR_MUTATION);

function opdaterDifference(uuid: string, difference: number) {
  opdaterFigur({ uuid: uuid, difference: difference });
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (!_unref(figurLoading))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: {
          name: 'minifigisaet',
          params: { minifigUuid: _unref(figur).uuid }
        },
            role: "button"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                (_unref(figur).url != undefined)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("img", {
                        class: "img-fluid",
                        style: {"object-fit":"contain"},
                        src: _unref(figur).url,
                        alt: _unref(figur).navn
                      }, null, 8, _hoisted_4)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'image'] })
                    ]))
              ])
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h6", _hoisted_7, _toDisplayString(_unref(figur).navn), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_font_awesome_icon, { icon: "hashtag" }),
              _createTextVNode(" " + _toDisplayString(_unref(figur).nummer), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (props.antalISaet != undefined)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(props.antalISaet), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(figur).antalFigurer + Number(_unref(figur).difference)), 1))
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("input", {
                  type: "number",
                  value: Number(_unref(figur).difference),
                  placeholder: "Difference",
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (opdaterDifference(_unref(figur).uuid, $event.target.value))),
                  style: {"max-width":"4em"}
                }, null, 40, _hoisted_15)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createTextVNode(_toDisplayString(_unref(figur).antalFigurer) + " ", 1),
                (props.antalISaet != undefined)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, " (" + _toDisplayString(_unref(figur).antalFigurer + Number(_unref(figur).difference)) + ")", 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})